import React from 'react';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Seo from 'sharedComponents/Seo';
import { createBidRequestEvent } from 'utils/gtmHelper';

import MortgageSurveyPresenter from 'presenters/MortgageSurveyPresenter';

import useApp from 'reducers/hooks/useApp';
import useFirebaseChat from 'reducers/hooks/firebase/useChat';
import useChats from 'reducers/hooks/useChats';
import useBidRequest from 'reducers/hooks/useBidRequest';
import useMortgageSurvey from 'reducers/hooks/useMortgageSurvey';
import { appRoutes } from 'routes';

import BuyerRegistration from './components/BuyerRegistration';
import Survey from './components/Survey';

import useStyles from './useStyles';

const NonAuthSurveyPage = props => {
  const { removeQuoteBox } = props;
  const classes = useStyles();
  const history = useHistory();
  const { loadChats } = useChats();
  const { loadCurrentUser } = useApp();
  const { t } = useTranslation();

  const { saveAndOpenBidRequest } = useBidRequest();
  const {
    surveyValues,
    discardSurveyValues,
    surveyPassed,
    setSelectedMortageSurveyFlow,
    selectedMortgageSurveyFlow,
    setInitialSurveyValues,
  } = useMortgageSurvey();
  const { setNeedToSelectChat } = useFirebaseChat();

  const handleCreateRequest = async () => {
    const attrs = MortgageSurveyPresenter.buildBidRequestAtrributes(surveyValues);
    const value = MortgageSurveyPresenter.calculateConversionValue(surveyValues);
    createBidRequestEvent(value);
    discardSurveyValues();
    await loadCurrentUser();
    await saveAndOpenBidRequest(attrs);
    loadChats();
    setNeedToSelectChat(true);
    history.push(appRoutes.messagesPath());
  };

  if (surveyPassed) return <BuyerRegistration onFinish={handleCreateRequest} />;

  return (
    <Box width="100%" height="100%" display="flex" flexDirection="column" alignItems="center">
      <Seo title={t('meta.NonAuthSurveyPage.title')} />
      <Box className={classes.paper}>
        <Box className={classes.survey}>
          <Survey
            onSelectFlow={setSelectedMortageSurveyFlow}
            selectedFlow={selectedMortgageSurveyFlow}
            surveyValues={surveyValues}
            setInitialSurveyValues={setInitialSurveyValues}
            removeQuoteBox={removeQuoteBox}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default NonAuthSurveyPage;



// WEBPACK FOOTER //
// ./src/components/NonAuthSurveyPage/NonAuthSurveyPage.js